// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-container":"BreadcrumbSection_breadcrumb-container__BbKRr"};